import { SVGAttributes } from 'react';

export function LandscapeToPortraitIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 9c0-2.357 0-3.536-.732-4.268S9.357 4 7 4s-3.536 0-4.268.732S2 6.643 2 9m5 13h8c2.357 0 3.535 0 4.268-.732C20 20.535 20 19.357 20 17s0-3.536-.732-4.268C18.535 12 17.357 12 15 12H7c-2.357 0-3.536 0-4.268.732S2 14.643 2 17s0 3.535.732 4.268S4.643 22 7 22M18.5 2L16 4.5L18.5 7M17 4.5c2.357 0 3.535 0 4.268.732S22 7.143 22 9.5"
      />
    </svg>
  );
}
